export enum UserDefinitionIds {
  CustomerUDID = 523,
  LenderUDID = 21,
  ContactUDID = 528,
  SuppliersUDID = 26,
  BrokersUDID = 522,
  AccountsUDID = 527,
  IntroducersUDID = 641
}

export enum UserDefinitionNames {
  Customers = 'Customers',
  Lenders = 'Lenders',
  Contacts = 'Contacts',
  Suppliers = 'Suppliers',
  Brokers = 'Brokers',
  Accounts = 'Accounts',
  Introducers = 'Introducers'
}

export enum LenderRuleIds {
  SendProposalForm = 1233 | 2071 | 1974 | 2291
}

export enum LenderObjectDefinitionIds {
  Proposal = 3397
}

export const globalIds = {
  accountSynergyFinanceId: 7958,
  accountCommissionId: 20267,
  rules: {
    GDPR_Rules: [
      212, 137, 1620, 49, 1293, 145, 1424, 1327, 1481, 2062, 1968, 2130, 2285
    ],
    TOBA_Rules: [1538, 1311, 1753],
    brief_Rules: [216, 1358, 2135],
    feeSchedule_Rules: [215, 1322, 2138],
    FFF_Rules: [1226, 109, 1621, 196, 1294, 1328, 1969, 2131, 2286],
    decisionPrinciple_Rules: [1229],
    formalOffer_Rules: [226],
    paidOut_Rules: [1334],
    referral_Rules: [1329, 1484],
    referralFeeInvoice: [1487],
    invoiceAdaptiveMoney: [1541],

    // Consumer Duly
    // 1611 1612 1613 Requested to be removed By Arisha.
    consumerDuly_Rules: [1624],

    // Facility Acceptance/Product
    // 1610, 1614 Requested To be Removed By Arisha
    facilityAcceptanceProduct: [1610, 1614, 2068, 1971, 2288],

    // Commission Invoice
    // 1230, 53, 156, 1430, 1299 Requested By Arisha to be Removed
    commissionInvoice_Rules: [1630, 156, 1540, 1485, 1615],

    // Documents
    satisfactionDocument_Rules: [
      228, 1234, 1635, 1235, 1306, 1546, 1547, 2088, 1991, 2308, 2152
    ],

    // Update
    updateFormalOffer: [1605],
    updateLenderDecision_Rules: [1460, 2309, 1636, 1462, 1463, 1465, 1466],
    updateQuoteDecision_Rules: [1542, 1637, 1543, 1544, 2166, 2313],
    updateConsumerDuly_Rules: [1603],

    // Customer
    customerDocs_Rules: [
      138, 1625, 201, 1297, 1419, 1429, 20, 1344, 1758, 1980, 2140, 2297
    ],

    // 1296 Requested To Be Removed By Arisha
    decisionCustomer_Rules: [1623, 203, 1428],

    // Quotes
    indicativeQuotes_Rules: [221],
    quote_Rules: [17, 1622, 50, 1295, 1471, 1470, 2067, 1970, 2133, 2287],

    // Lender
    enquiryLender_Rules: [220],
    lenderCommission_Rules: [1222],
    lenderCommissionPayout_Rules: [
      1168, 139, 2298, 1631, 202, 1350, 2078, 1981
    ],
    lenderCommissionPayoutContact_Rules: [
      1606, 1447, 2299, 1632, 1453, 1457, 2079, 1982
    ],

    // 93 200 1343 Requested To Be Removed By Arisha
    lenderDecision_Rules: [1343],
    lenderPayingFee: [1389, 2163],

    // Request
    requestSupplierInvoice_Rules: [205, 2075, 1978],
    requestPayoutConfirmationLender_Rules: [1303, 2149],
    requestPayoutConfirmationContact_Rules: [1455, 2150],
    requestAppraisalFee_Rules: [229, 1317, 2153],
    requestBrokerFee_Rules: [1220, 1319, 2156],

    // Proposal
    proposalForm_Rules: [
      225, 1233, 1628, 51, 1298, 150, 1427, 1345, 1761, 2071, 1974, 2143, 2291
    ],
    proposalToProposalContract_Rules: [
      1228, 1446, 1629, 1452, 1454, 1458, 1459, 1456, 1762, 2072, 1975, 2144,
      2292
    ],

    // Fees
    appraisalFeeCustomer_Rules: [1153, 1385, 2159],
    brokerFeeCustomer_Rules: [1161],
    brokerFeeLender_Rules: [1165, 1392, 1607, 2164, 2167]
  },
  customer: {
    addresses: {
      AddressObjectDefinition: 2854
    },
    shareholders: {
      ShareHolderObjectDefinition: 3724
    },
    directors: {
      DirectorsObjectDefinition: 2853
    },
    entity: [3464, 3602],
    lenderProposal: {
      LenderProposalObjectDefinition: [
        LenderObjectDefinitionIds.Proposal,
        3500,
        3497
      ],
      LenderProposalFields: {
        lender: [21159, 21961, 24490]
      }
    },
    partiesAndContacts: {
      ObjectDefId: 3625,
      Customer: 23274,
      SelectedCustomer: 23115,
      PrimaryContact: 23108,
      LenderProposalContact: 23116,
      LenderPayoutsContact: 23109,
      SelectedBroker: 23111
    },
    proposalComments: {
      background: [21641, 21975],
      project: [21642, 21976],
      financials: [21643, 21977],
      summary: [21644, 21978]
    },
    quotes: {
      QuotesObjectDefinition: [2840]
    },
    assets: {
      AssetsObjectDefinition: [2838]
    }
  },
  borrower: {
    companyDetails: [18318, 18319, 23280, 21881, 18448]
  },
  supplier: {
    assetDetail: {
      id: 2838,
      supplier: 21944,
      supplierContact: 23270,
      make: 18309,
      model: 18310,
      deliveryDate: 24682
    }
  },
  // Message Hub Rules:
  ruleLists: {
    BorrowerContactRules: [
      216, 214, 215, 221, 1229, 226, 228, 1153, 1161, 1226, 109, 17, 1233, 205,
      93, 138, 139, 1230, 1234, 196, 50, 200, 201, 1235, 1294, 1311, 1295, 1358,
      1322, 1296, 1297, 1306, 1341, 1342, 1343, 1344, 1369, 203, 1419, 1458,
      1428, 1429, 1459, 1538, 1610, 1612, 1611, 2039, 2040, 1812, 1810, 2067,
      2076, 2077, 2078, 2083, 2088, 2071, 2068, 1969, 1970, 1971, 1974, 1978,
      1979, 1980, 1981, 1986, 1991, 2132, 2131, 2133, 2135, 2138, 2139, 2140,
      2152, 2286, 2287, 2288, 2291, 2295, 2296, 2297, 2298, 2303, 2308
    ],
    LenderRules: [
      LenderRuleIds.SendProposalForm,
      139,
      2298,
      202,
      1298,
      2143,
      1303,
      2149,
      1345,
      1350,
      150,
      1427,
      2078,
      1981
    ],
    LenderProposalRules: [1228, 51],
    LenderPayoutRules: [227],
    AccountsRules: [
      1230, 229, 1220, 1222, 53, 1299, 1317, 1319, 1346, 1430, 156, 2083, 1986,
      2145, 2153, 2156, 2303
    ],
    SupplierContact: [205, 2075, 1978]
  },
  userDefinitionIds: {
    customerUDID: UserDefinitionIds.CustomerUDID,
    lenderUDID: UserDefinitionIds.LenderUDID,
    contactUDID: UserDefinitionIds.ContactUDID,
    suppliersUDID: UserDefinitionIds.SuppliersUDID,
    brokersUDID: UserDefinitionIds.BrokersUDID,
    accountsUDID: UserDefinitionIds.AccountsUDID,
    introducersUDID: UserDefinitionIds.IntroducersUDID
  },
  objectDefinitionIds: {
    assetDetailOBID: 2838,
    proposalComments: [3457, 3501],
    viewer: [3482, 2839, 95]
  },
  stepProcesses: {
    supplierRequestInvoice: [1521, 2514, 2537, 2642],
    commissionInvoices: [
      1750, 1522, 1550, 2218, 2250, 1618, 2290, 2293, 2307, 2357, 2416, 2644,
      2516, 2539
    ]
  },
  processInstanceStep: {
    quoteSteps: [1502, 2243, 2209, 2211, 2510, 2558]
  }
};
